import { Chip, IconButton, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import { AttachmentUpload } from './AttachmentUpload';
import axios from '../../util/Axios';
import ConfirmDialog from '../ConfirmDialog';
import { AttachmentPreview } from './AttachmentPreview';

export function AttachmentList({ testId }) {
  const [attachments, setAttachments] = useState([]);
  const [addFileVisible, setAddFileVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedFile, setSelectedFile] = useState();
  const [refresh, setRefresh] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [deleteSelection, setDeleteSelection] = useState();

  const closeUpload = () => {
    setAddFileVisible(false);
    setRefresh(true);
  };

  const selectFile = (index) => {
    setSelectedFile(attachments[index]);
    setSelectedIndex(index);
  };

  useEffect(() => {
    axios('/strokeTests/' + testId + '/attachments').then((resp) => {
      setAttachments(resp.data);
      setRefresh(false);
    });
  }, [testId, refresh]);

  const confirmDelete = (attachment) => {
    setDeleteSelection(attachment);
    setOpenDeleteConfirm(true);
  };

  const handleConfirmDeleteClose = (confirmed) => {
    setOpenDeleteConfirm(false);
    if (confirmed && deleteSelection) {
      deleteAttachment(deleteSelection.uuid);
    }
  };

  const deleteAttachment = (attachmentId) => {
    axios(`attachments/${attachmentId}`, {
      method: 'DELETE',
    }).then(() => {
      setDeleteSelection(null);
      setOpenDeleteConfirm(false);
      setRefresh(true);
      selectFile(-1);
    });
  };

  return (
    <>
      <Stack direction="row" alignItems="center">
        {addFileVisible ? (
          ''
        ) : (
          <IconButton aria-label="add file" onClick={() => setAddFileVisible(true)}>
            <AddIcon />
          </IconButton>
        )}
        <Typography variant="body1">Add file</Typography>
      </Stack>
      {addFileVisible ? <AttachmentUpload testId={testId} close={closeUpload} /> : ''}

      <Stack sx={{ marginBottom: '10px', marginTop: '10px' }} direction="row" gap={1}>
        {attachments.map((a, index) => (
          <Chip
            label={a.description || a.fileName}
            onClick={() => {
              selectFile(index);
            }}
            onDelete={() => confirmDelete(a)}
            deleteIcon={<DeleteIcon />}
            variant={selectedIndex !== index ? 'outlined' : 'filled'}
          />
        ))}
      </Stack>

      <AttachmentPreview file={selectedFile} />
      <ConfirmDialog onClose={handleConfirmDeleteClose} open={openDeleteConfirm} on text={`Delete ${deleteSelection?.fileName} ?`} title="Delete" />
    </>
  );
}
